import { createSlice } from '@reduxjs/toolkit';
import { API } from 'api';
import { setLocalData, handleLogout, setUserType } from 'api/authentication';
import { getLoginHeaders } from 'utils';

const initialState = {
	me: {},
};

export const authSlice = createSlice({
	name: 'auth', // name of the reducer
	initialState,
	reducers: {
		setUser: (state, { payload = {} }) => {
			state.me = payload;
		},
	},
});

export const userLogin = (data, setErrors) => async (dispatch) => {
	console.log('userLogin data', data);

	// Get location information for headers
	const { ip, latitude, longitude, permissionState } = await getLoginHeaders();

	const CREDENTIALS = {
		url: '/login',
		data,
		setErrors,
		config: {
			headers: {
				'X-Client-Public-IP': ip,
				'X-Latitude': latitude,
				'X-Longitude': longitude,
			},
		},
	};

	return API.common(CREDENTIALS).then(async (response) => {
		const resData = response?.data;
		console.log(response);
		setLocalData(resData);
		setUserType(resData.user_type);
		dispatch(setUser(resData));

		// Store location permission state in localStorage to show popup after redirect
		if (permissionState === 'denied' || permissionState === 'timeout') {
			localStorage.setItem('locationPermissionState', permissionState);
		}

		// Return response with permission state for UI handling
		return { ...response, permissionState };
	});
};

export const userLogout = () => async (dispatch) => {
	dispatch(setUser({}));
	handleLogout();
};

export const { setUser } = authSlice.actions;

export default authSlice.reducer;
